import React from "react";
import { useQuery } from "@apollo/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { sampleType, frequencyType } from "./../../../utilities/constants/WaterSystemConstants";
import { convertTimeStampToDate } from "./../../../utilities/commonFunctions/timeConversionFunctions";
import { GET_MONITORING_REQUIREMENTS_BY_FACILITY } from "../../../queries/archiveQrys/MonitoringScheduleReportQueries";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const MonitoringRequirementsByFacilityTable = (props) => {
  const { systemId } = props;

  const columns = [
    {
      Header: "",
      id: "expander",
      width: 30,
      Cell: ({ row }) => (
        <span {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? (
            <FontAwesomeIcon className='font-icon' icon={faCaretDown} cypressid={row.original.facilityId + "_mrbfd"} />
          ) : (
            <FontAwesomeIcon className='font-icon' icon={faCaretRight} cypressid={row.original.facilityId + "_mrbfr"} />
          )}
        </span>
      )
    },
    {
      Header: "ID",
      accessor: "facilityCode",
      width: 30
    },
    {
      Header: "Name",
      accessor: "facilityName"
    }
  ];

  const details = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "anlytName",
        width: 180
      },
      {
        Header: "# Samples Required",
        accessor: "sampleCount",
        width: 100
      },
      {
        Header: "# Samples Received",
        width: 100
      },
      {
        Header: "Type",
        accessor: (d) => {
          return d.sampleType ? sampleType[d.sampleType] : "";
        },
        width: 75
      },
      {
        Header: "Frequency",
        accessor: (d) => {
          return d.frequency ? frequencyType[d.frequency] : "";
        },
        width: 100
      },
      {
        Header: "Last Sample",
        accessor: (d) => {
          return d.lastSampleDate ? convertTimeStampToDate(d.lastSampleDate) : "";
        },
        width: 100
      },
      {
        Header: "Next Sample Due",
        accessor: "nextSampleDateRange",
        width: 175
      }
    ],
    []
  );

  const { loading, error, data } = useQuery(GET_MONITORING_REQUIREMENTS_BY_FACILITY, { variables: { systemId } });

  const subTable = React.useCallback(
    ({ row }) =>
      row.original.details ? (
        <DtsReactTable columns={details} data={row.original.details} headerColor='grey' cypressid="facReqTbl"/>
      ) : (
        "No Data"
      ),
    [details]
  );

  const expandedRows = React.useMemo(() => {
    if (data) {
      let arr = {};
      let d = data;
      if (d.getMonitoringRequirementsByFacility.length > 0) {
        d.getMonitoringRequirementsByFacility.forEach(function (elem, index) {
          if (elem.details) {
            if (elem.details.length > 0) arr[index] = true;
          }
        });
      }
      return arr;
    }
  }, [data]);

  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorHandler error={error} />;

  return (
    <>
      {data.getMonitoringRequirementsByFacility.length > 0 ? (
        <DtsReactTable
          data={data.getMonitoringRequirementsByFacility}
          columns={columns}
          headerColor='ddw'
          renderRowSubComponent={subTable}
          expandRows={true}
          expandedRowObj={expandedRows}
          subTableId={"_mrbfSubTable"}
        />
      ) : (
        <span>No Monitoring Requirements By Facility were found in the database.</span>
      )}
    </>
  );
};

export default MonitoringRequirementsByFacilityTable;
